import "../styles/FinalResults.css"
import appIcon from "../images/app_icon.jpg"
import { FinalResultsItem } from "./items/FinalResultsItem"
import { Statement } from "./Statement"
export const FinalResults = ({ allPlayerInfo, size, statement }) => {

    return (<div className={`final-results-container-${size}`}>
        <div className={`player-holdings-container-${size}`}>
            <div style={{ display: "flex" }}>
                <img src={appIcon} alt="" style={{ width: `${size === "lg" ? "3vw" : "40px"}`, height: `${size === "lg" ? "3vw" : "40px"}`, borderRadius: `${size === "lg" ? "1.5vw" : "20px"}`, marginRight: "10px" }} />
                <div className={`player-cards-header`}>
                    Final Results
                </div>
            </div>
            {allPlayerInfo.map((player, index) => {
                return <FinalResultsItem key={`player_result_${index}`} size={size} data={player} />
            })}
        </div>
        <Statement size={size} statement={statement} />
    </div>)
}